<script>
import DocumentReport from "../../components/ioffice/DocumentReport.vue";
import iGateReport from "../../components/igate/iGateReport.vue";
import PortalReport from "../../components/portal/PortalReport.vue";
import RpStatistical from "../../components/revenues_pay/RpStatistical.vue";
import MeetingStatistics from "../../components/ioffice/MeetingStatistics.vue";

export default {
  name: "Dashboard",
  components: {
    DocumentReport,
    RpStatistical,
    iGateReport,
    PortalReport,
    MeetingStatistics
  },
  data() {
    return {
    };
  },
  methods: {
  },
  async created() {},
};
</script>

<template>
  <div>

    <CRow>
      <!-- <CCol sm="4" >
        <iGateReport />
      </CCol> -->
      <CCol sm="8" >
        <PortalReport />
      </CCol>
      <CCol sm="4">
        <MeetingStatistics/>
      </CCol>
    </CRow>
    <!-- <RpStatistical /> -->
    <DocumentReport />
  </div>
</template>
